import styled from 'styled-components'

export const ViewerBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.9);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1001;
	padding: 2rem;

	@media (max-width: 600px) {
		padding: 1rem;
	}
`

export const ViewerContainer = styled.div`
	position: relative;
	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;

	img {
		max-width: 90vw;
		max-height: 80vh;
		object-fit: contain;
		border-radius: 8px;
	}
`

export const ViewerControls = styled.div`
	display: flex;
	gap: 0.75rem;
`

export const ViewerButton = styled.button`
	background: rgba(255, 255, 255, 0.15);
	color: white;
	border: none;
	padding: 0.5rem 1rem;
	border-radius: 6px;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.2s;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		background: rgba(255, 255, 255, 0.25);
	}
`

export const ViewerCloseButton = styled.button`
	position: absolute;
	top: -2.5rem;
	right: -1rem;
	background: transparent;
	border: none;
	color: white;
	font-size: 2rem;
	cursor: pointer;
	padding: 0.25rem;
	line-height: 1;

	&:hover {
		opacity: 0.7;
	}

	@media (max-width: 600px) {
		top: -2rem;
		right: 0;
	}
`
